<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import { formatMoney } from '../composables/commissionSheetForm';

const props = defineProps({
  amountCents: { type: Number, default: 0 },
  totals: { type: Object, required: true },
});

const { t } = useI18n();
const distributedClass = computed(() =>
  props.totals.nonCompanyPercentage >= 100
    ? 'text-lais-danger'
    : 'text-lais-text'
);
const companyClass = computed(() =>
  props.totals.companyMatches ? 'text-emerald-700' : 'text-lais-danger'
);
</script>

<template>
  <section class="grid gap-4 lg:grid-cols-2">
    <LaisCard
      :title="t('REAL_ESTATE_COMMISSION_INSTALLMENT.TOTALS.PERCENTAGE_TITLE')"
      prefix-icon="i-lucide-percent"
    >
      <dl class="grid gap-3 text-sm">
        <div class="flex justify-between gap-3">
          <dt>
            {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.TOTALS.DISTRIBUTED') }}
          </dt>
          <dd :class="distributedClass">
            {{
              t('REAL_ESTATE_COMMISSION_INSTALLMENT.COMMON.PERCENTAGE', {
                value: totals.nonCompanyPercentage,
              })
            }}
          </dd>
        </div>
        <div
          class="flex justify-between gap-3 border-t border-lais-border-soft pt-3"
        >
          <dt>
            {{
              t('REAL_ESTATE_COMMISSION_INSTALLMENT.TOTALS.COMPANY_REMAINING')
            }}
          </dt>
          <dd :class="companyClass">
            {{
              t('REAL_ESTATE_COMMISSION_INSTALLMENT.COMMON.PERCENTAGE', {
                value: totals.expectedCompanyPercentage,
              })
            }}
          </dd>
        </div>
        <div class="flex justify-between gap-3 font-semibold text-lais-primary">
          <dt>{{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.TOTALS.TOTAL') }}</dt>
          <dd>
            {{
              t('REAL_ESTATE_COMMISSION_INSTALLMENT.COMMON.PERCENTAGE', {
                value: 100,
              })
            }}
          </dd>
        </div>
      </dl>
    </LaisCard>
    <LaisCard
      :title="t('REAL_ESTATE_COMMISSION_INSTALLMENT.TOTALS.VALUE_TITLE')"
      prefix-icon="i-lucide-badge-dollar-sign"
    >
      <dl class="grid gap-3 text-sm">
        <div class="flex justify-between gap-3">
          <dt>
            {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.TOTALS.DISTRIBUTED') }}
          </dt>
          <dd class="text-lais-text">
            {{ formatMoney(totals.nonCompanyAmountCents) }}
          </dd>
        </div>
        <div
          class="flex justify-between gap-3 border-t border-lais-border-soft pt-3"
        >
          <dt>
            {{
              t('REAL_ESTATE_COMMISSION_INSTALLMENT.TOTALS.COMPANY_REMAINING')
            }}
          </dt>
          <dd :class="companyClass">
            {{ formatMoney(totals.expectedCompanyAmountCents) }}
          </dd>
        </div>
        <div class="flex justify-between gap-3 font-semibold text-lais-primary">
          <dt>
            {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.TOTALS.SHEET_TOTAL') }}
          </dt>
          <dd>{{ formatMoney(amountCents) }}</dd>
        </div>
      </dl>
    </LaisCard>
  </section>
</template>
